"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownCell = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var global_styles_1 = require("../../Global/global.styles");
var loading_button_1 = require("../../LoadingButton/loading_button");
var styled_components_1 = require("styled-components");
var shared_styles_1 = require("./shared.styles");
var dropdown_cell_styles_1 = require("./dropdown_cell.styles");
var PopoverContent = function (props) {
    var dropdownInlineLabel = props.dropdownInlineLabel, selectedValue = props.selectedValue, sendLabel = props.sendLabel, loadingLabel = props.loadingLabel, cancelLabel = props.cancelLabel, valueToLabelMap = props.valueToLabelMap, isLoading = props.isLoading, onSetData = props.onSetData, closePopover = props.closePopover;
    var _a = (0, react_1.useState)(selectedValue), dropdownValue = _a[0], setDropdownValue = _a[1];
    return (react_1.default.createElement(dropdown_cell_styles_1.PopoverContentContainer, null,
        react_1.default.createElement(dropdown_cell_styles_1.EditElements, null,
            react_1.default.createElement(shared_styles_1.EditElement, null,
                react_1.default.createElement(storm_ui_1.Dropdown, { inline: true, label: dropdownInlineLabel, selectedLabelOverride: valueToLabelMap.get(dropdownValue), onChange: setDropdownValue, selectedValue: dropdownValue, small: true }, Array.from(valueToLabelMap.entries()).map(function (_a) {
                    var dropdownItemValue = _a[0], dropdownItemLabel = _a[1];
                    return (react_1.default.createElement(storm_ui_1.DropdownItem, { key: dropdownItemLabel, value: dropdownItemValue }, dropdownItemLabel));
                }))),
            react_1.default.createElement(shared_styles_1.EditElement, null,
                react_1.default.createElement(loading_button_1.LoadingButton, { withMargin: false, isSmall: true, onClickSend: function () { return onSetData(dropdownValue); }, isLoading: isLoading, isDisabled: dropdownValue === selectedValue, loadingLabel: loadingLabel, sendLabel: sendLabel }, sendLabel)),
            react_1.default.createElement(shared_styles_1.EditElement, null,
                react_1.default.createElement(shared_styles_1.CancelButton, { withPadding: false, size: 'small', onClick: closePopover }, cancelLabel)))));
};
var DropdownCell = /** @class */ (function (_super) {
    __extends(DropdownCell, _super);
    function DropdownCell(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonRef = (0, react_1.createRef)();
        _this.state = { isPopoverOpen: false };
        return _this;
    }
    DropdownCell.prototype.componentDidUpdate = function (_, prevState) {
        if (prevState.isPopoverOpen && !this.props.cell.value.isLoading) {
            this.setState({ isPopoverOpen: false });
        }
    };
    DropdownCell.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(styled_components_1.ThemeConsumer, null, function (theme) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storm_ui_1.Popover, { isOpen: _this.state.isPopoverOpen, anchorEl: _this.buttonRef.current ? _this.buttonRef.current : undefined, offset: { x: -10, y: -10 }, withBackdrop: true, onClose: function (event) {
                    var portalElementId = theme.popover.portalElementId;
                    var portalElement = document.getElementById(portalElementId);
                    if (!portalElement.contains(event.target)) {
                        _this.setState({ isPopoverOpen: false });
                    }
                } },
                react_1.default.createElement(PopoverContent, __assign({}, _this.props.cell.value, { closePopover: function () { return _this.setState({ isPopoverOpen: false }); } }))),
            react_1.default.createElement(global_styles_1.FlexContainer, { ref: _this.buttonRef },
                react_1.default.createElement(shared_styles_1.ClickableCell, { onClick: function () { return _this.setState({ isPopoverOpen: true }); } },
                    react_1.default.createElement(shared_styles_1.EllipsisText, null, _this.props.cell.value.valueToLabelMap.get(_this.props.cell.value.selectedValue)),
                    react_1.default.createElement(shared_styles_1.SpacedIcon, { type: 'angle-down' }))))); }));
    };
    return DropdownCell;
}(react_1.Component));
exports.DropdownCell = DropdownCell;
